/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { RatingFactorDto } from '../model';
// @ts-ignore
import { RatingFactorRequest } from '../model';
/**
 * RatingFactorApiApiRatingFactorGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RatingFactorApiApiRatingFactorGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ratingFactor`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RatingFactorApiApiRatingFactorIdDelete - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RatingFactorApiApiRatingFactorIdDeleteAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiRatingFactorIdDelete', 'id', id)
    const localVarPath = `/api/ratingFactor/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RatingFactorApiApiRatingFactorIdPut - axios parameter creator
 * 
 * @param {number} id 
 * @param {RatingFactorRequest} [ratingFactorRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RatingFactorApiApiRatingFactorIdPutAxiosParamCreator (id: number, ratingFactorRequest?: RatingFactorRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiRatingFactorIdPut', 'id', id)
    const localVarPath = `/api/ratingFactor/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(ratingFactorRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RatingFactorApiApiRatingFactorPost - axios parameter creator
 * 
 * @param {RatingFactorRequest} [ratingFactorRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RatingFactorApiApiRatingFactorPostAxiosParamCreator (ratingFactorRequest?: RatingFactorRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ratingFactor`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(ratingFactorRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiRatingFactorIdDelete operation in RatingFactorApi.
 * @export
 * @interface RatingFactorApiApiRatingFactorIdDeleteRequest
 */
export interface RatingFactorApiApiRatingFactorIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof RatingFactorApiApiRatingFactorIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiRatingFactorIdPut operation in RatingFactorApi.
 * @export
 * @interface RatingFactorApiApiRatingFactorIdPutRequest
 */
export interface RatingFactorApiApiRatingFactorIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof RatingFactorApiApiRatingFactorIdPut
     */
    readonly id: number

    /**
     * 
     * @type {RatingFactorRequest}
     * @memberof RatingFactorApiApiRatingFactorIdPut
     */
    readonly ratingFactorRequest?: RatingFactorRequest
}

/**
 * Request parameters for apiRatingFactorPost operation in RatingFactorApi.
 * @export
 * @interface RatingFactorApiApiRatingFactorPostRequest
 */
export interface RatingFactorApiApiRatingFactorPostRequest {
    /**
     * 
     * @type {RatingFactorRequest}
     * @memberof RatingFactorApiApiRatingFactorPost
     */
    readonly ratingFactorRequest?: RatingFactorRequest
}

/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RatingFactorApiApiRatingFactorGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RatingFactorApiApiRatingFactorGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<RatingFactorDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RatingFactorApiApiRatingFactorIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RatingFactorApiApiRatingFactorIdDelete(requestParameters: RatingFactorApiApiRatingFactorIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RatingFactorApiApiRatingFactorIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RatingFactorApiApiRatingFactorIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RatingFactorApiApiRatingFactorIdPut(requestParameters: RatingFactorApiApiRatingFactorIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RatingFactorApiApiRatingFactorIdPutAxiosParamCreator(requestParameters.id, requestParameters.ratingFactorRequest, options, configuration);
    const request: () => AxiosPromise<RatingFactorDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RatingFactorApiApiRatingFactorPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RatingFactorApiApiRatingFactorPost(requestParameters: RatingFactorApiApiRatingFactorPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RatingFactorApiApiRatingFactorPostAxiosParamCreator(requestParameters.ratingFactorRequest, options, configuration);
    const request: () => AxiosPromise<RatingFactorDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
